import { render, staticRenderFns } from "./Witnesses.vue?vue&type=template&id=f56e9854&scoped=true&"
import script from "./Witnesses.vue?vue&type=script&lang=js&"
export * from "./Witnesses.vue?vue&type=script&lang=js&"
import style0 from "./Witnesses.vue?vue&type=style&index=0&id=f56e9854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56e9854",
  null
  
)

export default component.exports